$(document).ready(function() {
  let $ageInput = $("input[name='age']"),
    $decrementButton = $('.input-number-decrement'),
    $incrementButton = $('.input-number-increment');

  if ($ageInput.length > 0) {
    $('.select_age').click(function() {
      $(this).addClass('open');
      $(this).find('.dropdown_age').addClass('open');
    });

    if ($ageInput.val() !== 3) {
      updateAgeSpanValue();
    }

    $ageInput.bind('keyup mouseup change', function () {
      let newVal = parseInt($ageInput.val());

      if (newVal < vars.min_age) {
        $ageInput.val(vars.min_age);
      }

      if (newVal > vars.max_age) {
        $ageInput.val(vars.max_age);
      }

      updateAgeSpanValue();
    });

    $decrementButton.click(function () {
      let oldValue = $(this).parent().find("input").val(),
        newVal = parseInt(oldValue) - 1;

      if (newVal < vars.min_age) {
        newVal = vars.min_age;
      }

      $ageInput.val(newVal);
      updateAgeSpanValue();
    });

    $incrementButton.click(function () {
      let oldValue = $(this).parent().find("input").val(),
        newVal = parseInt(oldValue) + 1;

      if (newVal > vars.max_age) {
        newVal = vars.max_age;
      }

      $ageInput.val(newVal);
      updateAgeSpanValue();
    });

    function updateAgeSpanValue() {
      let val = $ageInput.val();

      $('.select_age > span.value').html(val);

    }
  }
});
